<script setup>
const props = defineProps({
  lottie: {
    type: String,
    required: true,
  },

  h2: {
    type: String,
    required: true,
  },
  body: {
    type: String,
  },
  subtitle: {
    type: String,
  },
  cta: {
    type: Object,

    validate: (value) => {
      return typeof value.label === "string" && typeof value.path === "string";
    },
  },
  cta2: {
    type: Object,

    validate: (value) => {
      return typeof value.label === "string" && typeof value.path === "string";
    },
  },
});
</script>

<template>
  <section
    aria-label="Szybki start"
    class="font-iq-paragraph leading-iq-paragraph tracking-iq-paragraph text-iq-paragraph-color"
  >
    <div class="grid grid-cols-1 md:grid-cols-4">
      <div class="col-span-1 md:col-span-3 order-2 md:order-1 px-2 md:px-0">
        <h2
          class="flex items-center gap-3 font-iq-header leading-iq-header tracking-iq-header text-iq-header-color"
        >
          <span
            class="inline-flex size-10 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-iq-primary to-iq-primary/80 text-white shadow-sm"
          >
            <!-- rocket icon -->
            <Icon name="mdi:rocket-launch" />
          </span>
          <span class="text-3xl font-semibold md:text-4xl">{{ h2 }}</span>
        </h2>
        <p class="text-justify text-lg mt-5">
          {{ body }}
        </p>

        <div class="mt-8 flex flex-wrap items-center gap-3">
          <FlexuilibCta
            v-if="cta"
            :label="cta.label"
            :path="cta.path"
            :icon="cta?.icon"
            :type="cta?.type"
          />
          <FlexuilibCta
            v-if="cta2"
            :label="cta2.label"
            :path="cta2.path"
            :icon="cta2?.icon"
            :type="cta2?.type"
          />
        </div>

        <p class="mt-3 text-xs text-neutral-500 dark:text-neutral-400">
          {{ subtitle }}
        </p>
      </div>
      <FlexuilibMagicLottie class="aspect-video order-1 md:order-2" :src="lottie" />
    </div>
  </section>
</template>
